import { create } from "zustand";

const UserAuthStore = create((set, get) => ({
  user: null,
  userDetails: null,
  email: localStorage.getItem("email"),
  orgId: "",
  authStatus: "resolving",
  setUser: async (user, orgId) => {
    set({ user });
  },
  setAuthenticated: (user, orgId) => set({ user, orgId, authStatus: "authenticated" }),
  setAuthStatus: (authStatus) => set({ authStatus }),
  clearAuthSession: () => set({ user: null, orgId: "", authStatus: "unauthenticated" }),
  setQZConsentAdd: (value = true) => {
    const details = get().userDetails ? get().userDetails : {};
    set({
      userDetails: {
        ...details,
        qz_build_status: value,
      },
    });
  },
  setEmail: (email) => set({ email }),
  setOrgId: (value) => set({ orgId: value }),
}));

export default UserAuthStore;
